import React from 'react';
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Form as FormLayout } from "react-bootstrap";
import TextInput from "../../../../../Common/components/text-input";
import { formatFormTitle, FormikMultiFormSync } from "../../../../../../util/Helpers";
import SelectInput from "../../../../../Common/components/select-input";
import { IDENTIFICATION_DATA_OPTIONS } from "../../../../data/IdentificationDataOptions";

function BasicDetails(
    {
        dataKey,
        title,
        isEditable,
        initialValues: {
            username,
            email,
            firstName,
            lastName,
            middleName,
            phone,
            identificationData = {},
            userId,
            userGroup
        }
    }
) {
    const validationSchema = Yup.object({
        username: Yup.string().required('Required'),
        email: Yup.string().required('Required'),
        firstName: Yup.string().required('Required'),
        lastName: Yup.string().required('Required'),
        middleName: Yup.string(),
        phone: Yup.string().required('Required'),
        identificationData: Yup.object().shape({
            type: Yup.string().required('Required'),
            value: Yup.string().required('Required'),
        }),
    })

    const compiledInitialValues = {
        username,
        email,
        firstName,
        lastName,
        middleName,
        phone,
        identificationData,
        userId,
        userGroup
    }

    return (
        <div>
            <Formik
                validationSchema={validationSchema}
                initialValues={compiledInitialValues}
                validateOnMount={true}
                enableReinitialize={true}
            >
                {({ isValid }) =>
                    <Form>
                        <fieldset disabled={!isEditable}>
                            {formatFormTitle({ title, isValid })}
                            <FormLayout.Row>
                                <TextInput
                                    label="Username*"
                                    name="username"
                                    type="text"
                                />
                                <TextInput
                                    label="Email*"
                                    name="email"
                                    type="email"
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <TextInput
                                    label="First Name*"
                                    name="firstName"
                                    type="text"
                                />
                                <TextInput
                                    label="Last Name*"
                                    name="lastName"
                                    type="text"
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <TextInput
                                    label="Middle Name"
                                    name="middleName"
                                    type="text"
                                />
                                <TextInput
                                    label="Phone*"
                                    name="phone"
                                    type="text"
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <SelectInput
                                    label="ID Type*"
                                    name="identificationData[type]"
                                    options={IDENTIFICATION_DATA_OPTIONS}
                                />
                                <TextInput
                                    label="ID Value*"
                                    name="identificationData[value]"
                                    type="text"
                                />
                            </FormLayout.Row>
                            <FormikMultiFormSync name={dataKey} />
                        </fieldset>
                    </Form>
                }
            </Formik>
        </div>
    );
}

export default BasicDetails;